<template>
  <FullPageLayout>
    <div class="mx-auto mt-8 flex w-full max-w-[1100px]">
      <div class="hidden sm:block left-panel flex-shrink-0 w-[260px]">
        <CorporateMenu />
      </div>

      <div class="policy mx-4 sm:ml-8 w-full child__container space-y-4 mb-8">
        <h1>KİŞİSEL VERİLERİN KORUNMASI KANUNU KAPSAMINDA İLGİLİ KİŞİ BAŞVURU FORMU</h1>
        <p></p>
        <p>
          6698 Sayılı Kişisel Verilerin Korunması Kanunu’nda (
          <b>Kanun</b>
          ) “ilgili kişi” olarak tanımlanan kişiler, Kanun’un 11. maddesinde kişisel verilerinin işlenmesine ilişkin belirli haklar
          tanınmıştır. Kanunun 13. maddesinin 1. fıkrası uyarınca; veri sorumlusu olan Onedio Bilişim Yazılım Medya Tekn. San. ve Tic.
          A.Ş’ye (
          <b>Şirket</b>
          ) bu haklara ilişkin olarak yapılacak başvuruların yazılı olarak veya Kişisel Verilerin Korunması Kurulu (
          <b>Kurul</b>
          ) tarafından belirlenen diğer yöntemlerle tarafımıza iletilmesi gerekmektedir. Bu çerçevede "
          <u>yazılı</u>
          " olarak Şirketimize yapılacak başvuruların, bu formun çıktısı alınarak, başvuru sahibinin şahsen başvurusu ile veya noter
          vasıtası ile ya da başvuru sahibince 5070 Sayılı Elektronik İmza Kanunu’nda tanımlı olan “güvenli elektronik imza” ile imzalanarak
          Şirket kayıtlı elektronik posta adresine gönderilmek suretiyle tarafımıza iletilmesi gerekmektedir. Aşağıda, yazılı başvuruların
          ne şekilde tarafımıza ulaştırılacağına ilişkin yazılı başvuru kanalları özelinde bilgiler verilmektedir.
        </p>
        <p></p>
        <p></p>
        <table>
          <thead>
            <tr>
              <th><b>Başvuru Yöntemi</b></th>
              <th><b>Başvurunun Yapılacağı Adres</b></th>
              <th><b>Başvuru Gönderiminde Belirtilecek Bilgi</b></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><b>Şahsen Başvuru</b></td>
              <td><span>Mustafa Kemal Mah. Dumlupınar Bulv. No:280 (Yeni ODTÜ Teknokent Binası) Kat:4 No:2 06530 Çankaya/Ankara</span></td>
              <td><span>Zarfın üzerine “Kişisel Verilerin Korunması Kanunu Kapsamında Bilgi Talebi” yazılacaktır.</span></td>
            </tr>
            <tr>
              <td><b>Noter vasıtasıyla tebligat</b></td>
              <td><span>Mustafa Kemal Mah. Dumlupınar Bulv. No:280 (Yeni ODTÜ Teknokent Binası) Kat:4 No:2 06530 Çankaya/Ankara</span></td>
              <td><span>Tebligat zarfına “Kişisel Verilerin Korunması Kanunu Kapsamında Bilgi Talebi” yazılacaktır.</span></td>
            </tr>
            <tr>
              <td><b>Güvenli Elektronik İmza</b></td>
              <td><span>onedio@onedio.hs06.kep.tr</span></td>
              <td><span>E-posta’nın konu kısmına “Kişisel Verilerin Korunması Kanunu Kapsamında Bilgi Talebi” yazılacaktır.</span></td>
            </tr>
          </tbody>
        </table>
        <p></p>
        <p></p>
        <p>
          Tarafımıza iletilmiş olan başvurular Kanunun 13. maddesinin 2. fıkrası gereğince, talebin niteliğine göre talebin bizlere yukarıda
          belirlenen yöntemlerden birisi ile tarafımıza ulaştığı tarihten itibaren otuz (30) gün içerisinde yanıtlandırılacaktır.
          Yanıtlarımız ilgili Kanunun 13. maddesi hükmü gereğince yazılı veya elektronik ortamdan başvuru sahibine ulaştırılacaktır. Talebin
          ayrıca bir maliyet gerektirmesi durumunda Kurul tarafından yayımlanan “Veri Sorumlusuna Başvuru Usul ve Esasları Tebliği” ‘ne
          göre; on sayfanın üzerindeki her sayfa için 1 Türk Lirası işlem ücreti; başvuruya cevabın CD, flash bellek gibi bir kayıt
          ortamında verilmesi halinde veri sorumlusu tarafından talep edilebilecek ücret, kayıt ortamının maliyetini geçmeyecek şekilde
          talep edilecektir.
        </p>
        <p></p>
        <p><b>I. Başvuru sahibinin tanınmasına ve başvurusu ile ilgili kendisiyle iletişim kurulmasına ilişkin bilgiler:</b></p>
        <p></p>
        <p><b>Adı ve Soyadı :</b></p>
        <p><b>T.C Kimlik numarası :</b></p>
        <p><b>Adres :</b></p>
        <p><b>Telefon numarası :</b></p>
        <p><b>E-posta Adresi :</b></p>
        <p></p>
        <p><b>II. Şirketimizle olan ilişkinize ilişkin açıklamalar (aday, çalışan, tedarikçi, müşteri, ziyaretçi gibi):</b></p>
        <p style="height: 200px"></p>
        <p>
          <b>
            III. Lütfen Kişisel Verilerin Korunması Kanunu kapsamındaki talebinizi, bilgi almak istediğiniz veri türünü, aktarım şeklini,
            uygulamayı, iş sürecini detaylı olarak belirtiniz:
          </b>
        </p>
        <p style="height: 200px"></p>
        <p><b>VI. Lütfen başvurunuza vereceğimiz yanıtın tarafınıza bildirilme yönetimini seçiniz.</b></p>
        <div class="flex flex-col space-y-4">
          <div class="flex items-start">
            <div class="checkbox mr-4"></div>
            <p>Adresime gönderilmesini istiyorum.</p>
          </div>
          <div class="flex items-start">
            <div class="checkbox mr-4"></div>
            <p>E-posta adresime gönderilmesini istiyorum.</p>
          </div>
          <div class="flex items-start">
            <div class="checkbox mr-4"></div>
            <p>
              Elden teslim almak istiyorum. (Vekâleten teslim alınması durumunda teslim alacak kişinin
              <br />
              noter onaylı vekâletname veya yetki belgesi bulunması gerekmektedir.)
            </p>
          </div>
        </div>
        <p><b>IV. Açıklamalar</b></p>
        <p></p>
        <p>
          İşbu başvuru formu, Şirketimiz ile olan ilişkinizi tespit ederek, varsa, Şirketimiz tarafından işlenen kişisel verilerinizi
          eksiksiz olarak belirleyerek, ilgili başvurunuza doğru ve kanuni süresinde cevap verilebilmesi için tanzim edilmiştir. Hukuka
          aykırı ve haksız bir şekilde veri paylaşımından kaynaklanabilecek hukuki risklerin bertaraf edilmesi ve özellikle kişisel
          verilerinizin güvenliğinin sağlanması amacıyla, kimlik ve yetki tespiti için Şirketimizin ek evrak ve malumat (Nüfus cüzdanı veya
          sürücü belgesi sureti vb.) talep etme hakkı saklıdır. Form kapsamında iletmekte olduğunuz taleplerinize ilişkin bilgilerin doğru
          ve güncel olmaması ya da yetkisiz bir başvuru yapılması halinde Şirketimiz, söz konusu yanlış bilgi ya da yetkisiz başvuru
          kaynaklı taleplerden dolayı mesuliyet kabul etmemektedir. Bu formda paylaştığınız kişisel verileriniz, Kanun kapsamındaki
          talebinizin değerlendirilmesi, neticelendirilmesi, ilgili tüm sürecin yönetilmesi ve bu amaçlarla sizlerle iletişime geçilebilmesi
          amaçlarıyla sınırlı olarak işlenecektir. Talebiniz, talebin niteliğine göre avukatlarımıza, şikâyet yönetimi, kalite kontrol,
          denetleme ve risk analizi alanında hizmet sunan iş ortaklarımıza ve hizmet sağlayıcılarımıza, kanunen yetkili kamu kurumları ve
          özel kişilere aktarılabilecektir.
        </p>
        <p></p>
        <p><b>VI. Beyan</b></p>
        <p></p>
        <p>
          Kişisel Verilerin Korunması Kanunu uyarınca yapmış olduğum başvurunun, yukarıda belirttiğim çerçevede sonuçlandırılmasını talep
          eder, işbu formda belirtmiş olduğum bilgi ve belgelerin doğru, güncel ve şahsıma ait olduğunu kabul, beyan ve taahhüt ederim.
        </p>
        <p></p>
        <p><b>İsim :</b></p>
        <p><b>Tarih :</b></p>
        <p><b>İmza :</b></p>
      </div>
    </div>
  </FullPageLayout>
</template>
<script>
import { defineComponent, useContext, useMeta, useRoute } from '@nuxtjs/composition-api';
import FullPageLayout from '@/modules/common/components/layout/FullPageLayout';
import CorporateMenu from '~/modules/corporate/components/CorporateMenu';
import { HOST_URL } from '~/constants/config';
export default defineComponent({
  components: {
    CorporateMenu,
    FullPageLayout,
  },
  head: {},
  setup() {
    const route = useRoute();
    const { $cache } = useContext();
    $cache('public, max-age=60');
    useMeta(() => {
      const path = route.value.path;
      return { link: [{ hid: 'canonical', rel: 'canonical', href: HOST_URL + path }] };
    });
    return {};
  },
});
</script>
<style>
table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 10px;
}
.checkbox {
  width: 25px;
  height: 25px;
  border: 1px solid black;
  border-radius: 4px;
}
</style>
